import React from "react"

export default ({ blocks, classNames }) => (props, editor, next) => {
  const { node } = props
  switch (node.type) {
    case blocks.list_item_child: {
      return (
        <span className={classNames.list_item_child} {...props.attributes}>
          {props.children}
        </span>
      )
    }
    default:
      return next()
  }
}
